import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import '../styles/global.css'; // Seu CSS global
import MaxMarcia from '../assets/fotos/Max_Marcia.jpeg';
import Brasao5Anos from '../assets/fotos/Brasao_5Anos.png';
import axios from 'axios';
import { Cake, CalendarMonth, WavingHand } from '@mui/icons-material';
// import CookieBanner from './CookieBanner';

function BemVindo() {
  const [isLoadingMOD, setIsLoadingMOD] = useState(false);
  const [aniversarios, setAniversarios] = useState([]);

  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Boas Vindas",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  useEffect(() => {
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    setIsLoadingMOD(true);
    axios
      .post(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=obtemAniversarios', null,
        {
          headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=utf-8",
          }
        }
      )
      .then((response) => {
        setAniversarios(response.data);
        setIsLoadingMOD(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoadingMOD(false);
      });
},[])

  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div className='headerMain'>
          <label className='labelTitulo' >O Moto Grupo Brasil Extremos está expandindo a cada dia.</label>
          <label className='labelTitulo' >Venha fazer parte dessa grande família!</label>
        </div>
        <div className='containerMain'>
          <div className='boxLeft'>
            <img className='fotoMain br10' src={Brasao5Anos} alt="Moto Grupo Brasil Extremos"></img>
          </div>
          <div className='boxCenter'>
            <h2 className='title'>Bem Vindo! <WavingHand style={{ width: 30, height: 30 }} /></h2>
            <p className='text'>Seja bem vindo ao site do Moto Grupo Brasil Extremos.</p>
            <p className='text'>Aqui você encontrará informações sobre nossas atividades, eventos e como se juntar a nós.</p>
            <p className='text'>Explore o site e sinta-se à vontade para entrar em contato conosco para mais informações.</p>
            <p className='text'>Estamos ansiosos para vê-lo em nossas próximas aventuras sobre duas rodas!</p>
            <br></br>
            <p className='text'>
            O MOTO GRUPO BRASIL EXTREMOS teve sua origem graças a iniciativa do nosso grande amigo MAX SILVA, que ao se preparar para mais uma de suas aventuras, criou um grupo de Whatsapp com pessoas de diversos locais os quais teve contato pelo seu canal do Youtube, da sua página do Instagran e as pessoas que foi conhecendo pelos caminhos que percorreu.
            Esse grupo inicialmente começou a oferecer apoio a todos os irmãos e irmãs motociclistas nas estradas e que estivesse na rota de algum membro do grupo.
            O nome do grupo de Whatsapp é Brasil Extremos, então foi criado e fundado por alguns membros o MOTO GRUPO BRASIL EXTREMOS.
            Hoje temos membros e associados de 14 estados e o Distrito Federal, e estamos crescendo a cada mês.
            O Moto Grupo já participou de alguns eventos hasteando a bandeira e no ano de 2021 realizando a primeira confraternização com membros da região de São Paulo.
            A ideia nasceu em Agosto/2021 e fundado oficialmente em Outubro/2021 quando foi realizado a primeira Assembleia da Associação.
            </p>
            <br></br>
            <p className='text fs08'>Gestão em Exercício 2025 a 2027</p>
            <p className='text fs09'>ALEX RASQUINHO (SP) - Presidente</p>
            <p className='text fs09'>RONISON SOUSA (SP) - Vice-Presidente</p>
            <p className='text fs09'>CLÁUDIO SILVA (SP), SANDRO OLIVER (SP), EDUARDO LACERDA (SP)</p>
            <p className='text fs09'>LÉO (PB), CLÉSIO (PE) e CAPA (SP) - Diretoria</p>

            
          </div>
          {aniversarios.length > 0 ? (
            
          <div className='boxRight'>
            <div className='w90 text-align-center p1 mb1 mr1' style={{ verticalAlign: 'middle', display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
              <Cake style={{ width: 40, height: 40 }} />
              <span className='fs10'>ANIVERSARIANTES DO MÊS</span>
              <CalendarMonth style={{ width: 40, height: 40 }} />
              </div>
            {/* <ul className='list'> */}
              {isLoadingMOD ? <li><CircularProgress /></li> : 
                aniversarios.length > 0 ? (aniversarios 
                .filter(val => {return val})
                .map(aniversariante => (
                    <div key={aniversariante.IdPessoa} className="w90" >
                      <div className='bgTrans clrWhite box-shadow text-align-center p1 mb1 mr1 br10'>
                        <div className="fs09">{aniversariante.pesApelido}</div>
                        <div className="fs10"><b>{aniversariante.dia}/{aniversariante.mes} ({aniversariante.idade})</b></div>
                        <div className="fs06">{aniversariante.pesNome}</div>
                      </div>
                    </div>
                  )
                )) : null
              }
            {/* </ul> */}
          </div>) : null}
        </div>
        
      </main>
      {/* <CookieBanner /> */}
    </div>
  );
}

export default BemVindo;